<template>
	<div class="sk_eye_android_user_help">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">使用说明</h1>
		<h3 class="doc_main_h3">
			概述
		</h3>
		<p class="doc_main_p"> 该文档将详细说明如何在Android平台上快速集成该SDK，并通过调用SDK接口使用SKEye图像识别服务。</p>
		<h3 class="doc_main_h3">
			系统需求
		</h3>
		<p class="doc_main_p">Android4.0及以上版本系统</p>
		<h3 class="doc_main_h3">
			使用步骤
		</h3>
		<p class="doc_main_p">
			支持使用Android Studio、Eclipse进行集成使用，在新建工程后，将SDK拷贝至对应目录，具体使用可参考Demo工程。
			<img src="../../../static/images/objectRecognition/android/1.png" class="ios_1_png">
		</p>
		
		<h3 class="doc_main_h3">
			Demo说明
		</h3>
		<p class="doc_main_p">
			演示案例是Android Studio工程。案例展示如何调用SKEyeSDK接口，图像识别结果会在案例界面上展示，并以log形式打印。
		</p>
		<h3 class="doc_main_h3">
			关键参数说明
		</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">api_key：String类型，指当前APP所申请的SKEye的API_KEY
api_secret：String类型，指当前APP所申请的SKEye的API_SECRET
service_name：String类型，指SKEye识别服务名称
ConstConfig.SKEyeSDK_SERVICE_NAME_OBJECT：String类型，指常见物品识别服务名称
ConstConfig.SKEyeSDK_SERVICE_NAME_FRUITS：String类型，指水果识别服务名称
bitmap：Bitmap类型，指Bitmap图片
image_id：String类型，图片id（方便确认请求顺序和返回顺序是否一致）
image_url：String类型，指图片的网络url/本地路径
image_YUVData：String类型，指图像的YUV数据byte数组
image_width：int类型，指图片的宽度
image_height：int类型，指图片的高度
rRateValue：float类型，指图像红色偏色率
gRateValue：float类型，指图像绿色偏色率
bRateValue：float类型，指图像蓝色偏色率
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['物体识别','SKEye-Android','使用说明'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.sk_eye_android_user_help{
		.ios_1_png{
			display: block;
			width: 200px;
			margin:20px auto;
		}
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skeyeandroid/SKEyeUserHelp.vue